import { render, staticRenderFns } from "./retaguarda.vue?vue&type=template&id=18ae4bfb&"
import script from "./retaguarda.vue?vue&type=script&lang=js&"
export * from "./retaguarda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports